import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import routes from "../../router/Config";
import { Layout } from "antd";
import HeaderNav from "../../components/Header";
import SliderNav from "../../components/Slider";
import { checkToken } from "../../components/common/Tool";
import "../../assets/styled/Admin.css";
const { Content } = Layout;

export default class SiderDemo extends React.Component {
  render() {
    checkToken(this.props.history);
    return (
      <Layout style={{ minHeight: "100%" }}>
        <SliderNav />
        <Layout>
          <HeaderNav />
          <Content
            style={{
              margin: "18px 16px",
              padding: 24,
              background: "#fff"
            }}
          >
            <Switch>
              {routes[2].routes.map((route, index) => (
                <Route
                  path={route.path}
                  key={index}
                  exact
                  component={route.component}
                />
              ))}
              <Redirect from="" to="/admin/news" />
            </Switch>
          </Content>
        </Layout>
      </Layout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/container/Admin/Admin.js